@if (columnModel.isEditable && !!control) {
    <arc-quick-search [formControl]="control | formControl" [config]="castedCellModel.type | arcQuickSearchConfig" class="h-full w-full" />
} @else {
    <arc-quick-search
        [formControl]="readonlyControl | formControl"
        [config]="castedCellModel.type | arcQuickSearchConfig"
        class="h-full w-full" />
}
